import React, { useEffect } from 'react';
import { useUnmount } from 'react-use';

import { connect } from 'react-redux';
import loadable from '@loadable/component';

import store from '../../redux/store';
import { getPages, resetPages } from '../../redux/modules/linksCard/action';
import { useDebounceLoading } from '../../utils/hookHelper';
import { forceToArray } from '../../utils/Helper';

import Loader from '../../components/Loader';
import UnderConstruction from '../../components/UnderConstruction';

import './LinksCard.scss';

const Links = loadable(() => import('../../widgets/Links'));

const LinksCard = (props) => {
  const { pageName, i18n, linksCard } = props;
  const debouncePageLoading = useDebounceLoading(linksCard);

  useEffect(() => {
    store.dispatch(getPages(pageName));
  }, [pageName]);

  useUnmount(() => {
    store.dispatch(resetPages());
  });

  const { locale } = i18n;
  const { data = {} } = linksCard || {};
  const content = ((data || {}).content || {}).content || {};
  const dataContent = content[locale] || {};
  const { under_construction = false } = content;

  // content
  const headline = props.title;
  const { image } = props;
  const { url } = props;
  const links = dataContent.links || '';

  const headlineEle = <>{headline && <h5>{headline}</h5>}</>;

  const moreButton = (
    <div className="child-more-item">
      <div className="item-more">
        <a target="_blank" className="button button--ghost-orange" href={url}>
          <span>Continua</span>
        </a>
      </div>
    </div>
  );

  const limitLinks = (links, limit) => {
    if (links) {
      return links.slice(0, limit);
    }
  };

  const mainContent = (
    <>
      <Links links={limitLinks(forceToArray(links), props.noOfLinks)} />
    </>
  );

  const pageEle = (
    <section className="container section-mainPage-LinksCard">
      <div className="row">
        <div className="col-12 col-lg-6">
          <div
            className="section-mainPage-LinksCard-m2-l"
            style={{ backgroundImage: `url(${image})` }}
            alt={props.alt}
          />
        </div>
        <div className="col-12 col-lg-6">
          <div className="section-mainPage-LinksCard-m2-r">
            {headlineEle}
            {under_construction && <UnderConstruction />}
            {!under_construction && mainContent}
            {!under_construction && moreButton}
          </div>
        </div>
      </div>
    </section>
  );

  return <>{debouncePageLoading ? <Loader /> : pageEle}</>;
};

const mapStateToProps = (state) => ({
  i18n: state.i18n,
  linksCard: state.linksCard,
});

const connectStore = connect(mapStateToProps, null, null, {
  pure: true,
})(LinksCard);

export { LinksCard as LinksCardComponent }; // <- For component Unit Test
export default connectStore;
